import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <div className="policy-container">
        <h1>Shipping</h1>
        <p>Orders are normally prepared within 1–2 business days. Tracking details are emailed after dispatch.</p>
        <h2>Shipping charge</h2>
        <p>A flat shipping fee of <strong>$9.99 USD</strong> applies to every order and is shown separately at checkout.</p>
        <h2>Delivery times</h2>
        <p>Estimated delivery times vary by destination and begin after dispatch. Customs or carrier delays may occasionally extend the estimate.</p>
        <h2>Delivery availability</h2>
        <p>We do not accept orders to destinations restricted by applicable sanctions or carrier rules. The available country list at checkout is authoritative.</p>
        <h2>Questions</h2>
        <p>For help with a delivery, email send@isanroute.space with your order number.</p>
        <div className="delivery-images">
          <img src="/generated/editorial/scene-36.webp" alt="Order prepared for delivery" />
          <img src="/generated/editorial/scene-37.webp" alt="Parcel ready for dispatch" />
        </div>
      </div>
    </div>
  );
}

export default Delivery;
